'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _countriesMin = require('../../../services/MapboxService/countries.min.json');var _countriesMin2 = _interopRequireDefault(_countriesMin);

var _PublishFormLocationInput = require('./PublishFormLocationInput.scss');var styles = _interopRequireWildcard(_PublishFormLocationInput);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Constants
// Styles
var PublishFormCountriesSelect = function (_Component) {_inherits(PublishFormCountriesSelect, _Component);function PublishFormCountriesSelect() {var _temp, _this, _ret;_classCallCheck(this, PublishFormCountriesSelect);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      inputValue: '' }, _this.


    checkMatches = function (option, lang, input) {
      var text = input || '';
      var words = text.split(' ');
      return words.reduce(
      function (acc, cur) {return acc && option[lang].toLowerCase().includes(cur.toLowerCase());},
      true);

    }, _this.

    handleInputChange = function (inputValue) {
      _this.setState({ inputValue: inputValue });
      return inputValue;
    }, _this.

    handleChange = function (selectedOption) {
      _this.props.onChangeCountry(selectedOption);
      _this.setState({ inputValue: selectedOption ? selectedOption.label : '' });
    }, _this.

    highlightedOption = function (option) {
      var input = _this.state.inputValue;
      var regex = new RegExp('(' + input + ')', 'i');
      var isMatch = function isMatch(lang) {return _this.checkMatches(option, lang, input);};
      var searchKey = option.label;
      if (isMatch('en')) {
        searchKey = option.en;
      } else if (isMatch('he')) {
        searchKey = option.he;
      } else if (isMatch('ru')) {
        searchKey = option.ru;
      }

      if (input) {
        var parts = searchKey.split(regex).map(function (p, i) {
          var id = i;
          return regex.test(p) ? _react2.default.createElement('strong', { key: 'part_' + p + id }, p) : p;
        });
        return _react2.default.createElement('div', { className: styles.selectOption }, parts);
      }
      return (
        _react2.default.createElement('div', { className: styles.selectOption }, option.label));

    }, _this.

    filterOption = function (option, inputValue) {
      var isMatch = function isMatch(lang) {return _this.checkMatches(option, lang, inputValue);};
      return isMatch('en') || isMatch('he') || isMatch('ru');
    }, _temp), _possibleConstructorReturn(_this, _ret);}PublishFormCountriesSelect.prototype.

  render = function render() {var _props =
    this.props,address = _props.address,country_name = _props.country_name,translate = _props.translate,isRtl = _props.isRtl,onChangeCountry = _props.onChangeCountry,locale = _props.locale;
    var countriesOptions = _countriesMin2.default.map(function (option) {return {
        key: option.id,
        id: option.id,
        value: locale === 'he' ? option.address[locale] : option.address.en,
        label: locale === 'he' ? option.address[locale] : option.address.en,
        en: option.address.en,
        he: option.address.he,
        ru: option.address.ru };});

    var countryValue = address.country_name || '';

    return (
      _react2.default.createElement('div', { className: styles.countriesWrap },
        _react2.default.createElement(_reactSelect2.default, {
          name: 'address.country_name',
          searchable: true,
          clearable: true,
          value: countryValue,
          options: countriesOptions,
          optionRenderer: this.highlightedOption,
          filterOption: this.filterOption,
          onChange: this.handleChange,
          onInputChange: this.handleInputChange,
          instanceId: 'publish_country',
          rtl: isRtl,
          placeholder: translate('country').toString(),
          noResultsText: translate('noResultsTitle').toString() })));



  };return PublishFormCountriesSelect;}(_react.Component);


PublishFormCountriesSelect.propTypes = {
  locale: _propTypes2.default.string,
  address: _propTypes2.default.object,
  country_name: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  onChangeCountry: _propTypes2.default.func };exports.default =


PublishFormCountriesSelect;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LocationInput/PublishFormLocationInput/PublishFormCountriesSelect.js
// module id = 2698
// module chunks = 0